import React, {ReactElement} from "react";

import Image, {ImageObject} from "../image/Image";
import LinkTag from "../buttons/link-tag/LinkTag";
import CTAButton, {CTA} from "../buttons/cta-button/CTAButton";

import {css} from "/src/utils/utils";

import * as styles from "./callout.module.scss";

export interface CalloutProps {
  headline: string;
  image?: ImageObject;
  cta: CTA;
  darkMode?: boolean;
  classes?: string;
}

const Callout = (props: CalloutProps): ReactElement => {
  const {headline, image, cta, darkMode, classes} = props;

  return (
    <div
      className={css(
        styles.callout,
        darkMode === true ? styles.calloutDark : "",
        classes!
      )}
    >
      {cta?.url && image && (
        <LinkTag
          classes={styles.callout__link}
          href={cta.url}
          ariaLabel={cta.label}
        >
          <Image image={image} classes={styles.callout__img} />
        </LinkTag>
      )}

      {!cta?.url && image && (
        <Image
          image={image}
          classes={css(styles.callout__img, styles.callout__imgPad)}
        />
      )}

      <div className={styles.callout__content}>
        <p className={css("p", styles.callout__headline)}>{headline}</p>

        {cta && <CTAButton kind="primary" cta={cta} />}
      </div>
    </div>
  );
};

export default Callout;
